import React, { FC } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { faSignOut } from '@fortawesome/pro-light-svg-icons';

import { HeaderItem } from '@eltoro-ui/components';

import './SideNavigationBar.scss';

export const SideNavigationBar: FC<{
  value: boolean;
  onClick: () => void;
  onClickDropdown: () => void;
  onLogOut: () => void;
  isAdmin: boolean;
}> = ({ value, onClick, onClickDropdown, onLogOut, isAdmin }) => {
  return (
    <div className={`side_nav_bar_container ${value ? '' : 'hide'}`}>
      <div className="shadow_container" />
      <div className="side_nav_bar_nested_container">
        <div className="icon_container">
          <FontAwesomeIcon className="cross_icon" icon={faPlusCircle} onClick={onClick} />
        </div>
        <div>
          <ul className="unorder_list">
            <li className="list">
              <HeaderItem
                UNSAFE_STYLE={{ paddingTop: '0', paddingBottom: '0' }}
                onClick={onLogOut}
                icon={<FontAwesomeIcon icon={faSignOut} />}
              >
                Logout
              </HeaderItem>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
